var map = {
	"./background.png": 100,
	"./confrigurator_logo.png": 123,
	"./icon_alert.png": 246,
	"./icon_city.png": 247,
	"./icon_cold.png": 125,
	"./icon_dimensions.png": 248,
	"./icon_extracold.png": 126,
	"./icon_frozen.png": 127,
	"./icon_height.png": 249,
	"./icon_length.png": 250,
	"./icon_storage.png": 251,
	"./icon_temperature.png": 252,
	"./icon_turnover.png": 253,
	"./icon_width.png": 254
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 124;